import { getItemsFromCollection } from "directus/src/operations";

export async function fetchProjectsForTimesheetLog({ date }) {
  try {
    const accessQuery = {
      fields: ["project"],
      groupBy: ["project"],
      filter: {
        _or: [
          {
            employee: {
              user: { _eq: "$CURRENT_USER" },
            },
            project: {
              status: { _eq: "active" },
            },
            job: {
              status: { _eq: "in_progress" },
              start_date: { _lte: date },
            },
          },
        ],
      },
      limit: -1,
    };

    const accessData = await getItemsFromCollection("project_access", accessQuery);
    const projectIds = accessData.map((item) => item.project);

    if (!projectIds.length) return [];

    const projectData = await getItemsFromCollection("projects", {
      fields: ["id", "name"],
      filter: {
        id: { _in: projectIds },
      },
      sort: ["name"],
      limit: -1,
    });

    return projectData;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchJobsForProject({ project, date }) {
  try {
    const accessQuery = {
      fields: ["job"],
      groupBy: ["job"],
      filter: {
        project: { _eq: project },
        job: { status: "in_progress" },
        _or: [
          {
            employee: {
              user: { _eq: "$CURRENT_USER" },
            },

            role: {
              _neq: "employee"
            }
          },
          {
            job: {
              employees: {
                employee: {
                  user: {
                    _eq: "$CURRENT_USER"
                  }
                },
                is_logging_restricted: {
                  _neq: true,
                },
              }
            }
          }
        ],
      },
      limit: -1,
    };

    const accessData = await getItemsFromCollection("project_access", accessQuery);
    const jobIds = accessData.map((item) => item.job).filter(Boolean);

    if (!jobIds.length) return [];

    const jobData = await getItemsFromCollection("jobs", {
      fields: ["id", "name", "disable_job_logging", "type"],
      filter: {
        id: { _in: jobIds },
      },
      sort: ["name"],
      limit: -1,
    });

    return jobData;
  } catch (error) {
    console.error("Error fetching jobs for project:", error);
    throw error;
  }
}

export async function fetchJMilestonesForJob({ job }) {
  try {
    const accessQuery = {
      fields: ["milestone"],
      groupBy: ["milestone"],
      filter: {
        job: { _eq: job },
        milestone: { status: "in_progress" },
        _or: [
          {
            employee: {
              user: { _eq: "$CURRENT_USER" },
            },
            role: { _neq: "employee" },
          },
          {
            project: {
              status: { _eq: "active" },
            },
          },
          {
            job: {
              employees: {
                employee: {
                  user: { _eq: "$CURRENT_USER" },
                },
                is_logging_restricted: { _neq: true },
              },
            },
          },
        ],
      },
      limit: -1,
    };

    const accessData = await getItemsFromCollection("project_access", accessQuery);
    const milestoneIds = accessData.map((item) => item.milestone).filter(Boolean);

    if (!milestoneIds.length) return [];

    const milestoneData = await getItemsFromCollection("milestones", {
      fields: ["id", "name"],
      filter: {
        id: { _in: milestoneIds },
      },
      sort: ["name"],
      limit: -1,
    });

    return milestoneData;
  } catch (error) {
    console.error("Error fetching milestones for job:", error);
    throw error;
  }
}

export async function fetchTags() {
  try {
    const query = {
      fields: ["id", "label"],
      filter: {
        for: {
          _eq: "timesheet",
        },
      },
      sort: ["label"],
    };
    const data = await getItemsFromCollection("tags", query);
    return data;
  } catch (error) {
    console.error("Error fetching tags:", error);
    throw error;
  }
}
